import { render, staticRenderFns } from "./UnblockConfirmationDialog.vue?vue&type=template&id=273370bb"
import script from "./UnblockConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./UnblockConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports